
import type { PropType } from 'vue'
import type { Route } from 'vue-router'
import { defineComponent, ref } from 'vue'
import { UiPopover } from './keen-ui'

export interface PopoverItem {
  id: string
  label: string
  icon?: string
  route?: Route | string
  target?: string
  selected?: boolean
  isCustom?: boolean
}

export default defineComponent({
  name: 'PopoverList',
  components: {
    UiPopover,
  },
  props: {
    items: {
      type: Array as PropType<Array<PopoverItem>>,
      default: () => [],
    },
    position: String,
    appendToBody: Boolean,
  },
  setup(): Record<string, any> {
    const baseClass = 'epb-popover-list'
    const instancePopoverList = ref(null)

    const close = (): void => {
      if (instancePopoverList.value) {
        instancePopoverList.value.close()
      }
    }

    return {
      baseClass,
      instancePopoverList,
      close,
    }
  },
})
